import { Link } from 'react-router-dom';
import { useMemo } from 'react';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const pathMap: Record<string, string> = {
  'category': '分类',
  'works': '作品集',
  'profile': '资料档案',
  'news': '最新动态',
  'community': '粉丝社区',
  'gallery': '精选图集',
  'interviews': '深度访谈',
  'article': '文章',
  'about': '关于我们',
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path ? `https://anzai-rara.com${item.path}` : undefined,
    })),
  }), [items]);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <span className="text-foreground-400 mx-1">/</span>
                )}
                {isLast || !item.path ? (
                  <span className="text-foreground-600 font-medium">{item.name}</span>
                ) : (
                  <Link
                    to={item.path}
                    className="text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}